"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");
/**
 * Procedure that signs KYC data for transfers.
 * This signature can be used to simulate updates to KYC data when checking if a transfer can be made or to actually modify said data at the moment of performing a transfer without having to do it in a separate transaction.
 * The signature has a period of validity which is specified by the parameters passed to the procedure
 */


var SignTransferData =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(SignTransferData, _Procedure_1$Procedur);

  function SignTransferData() {
    var _this;

    _classCallCheck(this, SignTransferData);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SignTransferData).apply(this, arguments));
    _this.type = types_1.ProcedureType.SignTransferData;
    return _this;
  }
  /**
   * Sign KYC data, passing the valid dates and extra kyc data
   *
   * Note this procedure will fail if:
   * - The signature validity period starting date (validFrom) is later than the end date (validTo)
   * - The validity period end date (validTo) is in the past
   */


  _createClass(SignTransferData, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this$args, kycData, validFrom, validTo, symbol, contractWrappers, securityToken, investorsData;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$args = this.args, kycData = _this$args.kycData, validFrom = _this$args.validFrom, validTo = _this$args.validTo, symbol = _this$args.symbol;
                contractWrappers = this.context.contractWrappers;
                _context.prev = 2;
                _context.next = 5;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 5:
                securityToken = _context.sent;
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](2);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 11:
                if (!(validFrom >= validTo)) {
                  _context.next = 13;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: 'Signature validity lower bound must be at an earlier date than the upper bound'
                });

              case 13:
                if (!(validTo < new Date())) {
                  _context.next = 15;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "Signature validity upper bound can't be in the past"
                });

              case 15:
                investorsData = kycData.map(function (_a) {
                  var kycExpiry = _a.kycExpiry,
                      address = _a.address,
                      rest = __rest(_a, ["kycExpiry", "address"]);

                  return Object.assign({
                    expiryTime: kycExpiry,
                    investorAddress: address
                  }, rest);
                });
                _context.next = 18;
                return this.addSignatureRequest(securityToken.signTransferData)({
                  validFrom: validFrom,
                  validTo: validTo,
                  investorsData: investorsData
                });

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));
    }
  }]);

  return SignTransferData;
}(Procedure_1.Procedure);

exports.SignTransferData = SignTransferData;